import cn from 'classnames';
import Image from 'next/image';
import type { FC } from 'react';
import React from 'react';

import RainbowHighlight from 'components/basic/RainbowHighlight';
import Typograf from 'components/basic/Typograf';
import { H1, H3 } from 'components/basic/Typography';
import { balls } from 'components/pagesComponents/landing/ForResearches/components/HowMakes/constants';
import { typeformUrl } from 'components/pagesComponents/landing/ForResearches/constants';

import s from './HowMakes.module.scss';

const HowMakes: FC = () => {
  const mobileBalls = balls.map(ball => {
    return (
      <div key={ball.text} className={s.mobileBall}>
        <img
          src={`/pagesImages/landing/for-researches/how-makes/${ball.image}`}
          alt=""
        />
        <H3>{ball.text}</H3>
      </div>
    );
  });

  return (
    <Typograf>
      <div className="mt-sm-23 mt-xm-17 mt-lg-20 mb-sm-6 mb-xm-9 mb-lg-6 mb-xl-10">
        <div className={s.howMakes}>
          <Image
            width={1217}
            height={553}
            src="/pagesImages/landing/for-researches/how-makes/how-makes.jpg"
            layout="intrinsic"
          />
        </div>
      </div>
      <H1 className="mb-sm-6 mb-xm-9 mb-lg-12 mb-xl-15">
        {/* @ts-ignore */}
        <a name="Ways-of-using-HRV-in-research">
          Learn how Welltory makes data collection and participant management
          simple
        </a>
      </H1>

      <div className={s.desktopBalls}>
        <div className={s.topText}>
          <H3>
            We’ll look into your draft research, agree on deadlines, prices and
            answer your questions.
          </H3>
          <H3>We share access to the app with you and provide instructions.</H3>
          <H3>We export the data of your research.</H3>
        </div>
        <img
          className={s.balls}
          src="/pagesImages/landing/for-researches/how-makes/balls.svg"
          alt=""
        />
        <div className={s.bottomText}>
          <H3>You receive a bill and contract, followed by payment.</H3>
          <H3>You can conduct your research.</H3>
        </div>
      </div>
      <div className={s.mobileBalls}>{mobileBalls}</div>
      <RainbowHighlight
        className={cn('mt-sm-23 mt-xm-20 mt-xl-30 mb-sm-23 mb-xm-20 mb-xl-25')}
        text={
          <>
            <span className="md-visible not-md-hidden">
              Collecting
              <span className="pre-wrap-mobile" style={{ width: '101%' }}>
                data is now as
              </span>
              <span className="pre-wrap-mobile">easy as ABC</span>
            </span>
            <span className="md-hidden">
              Collecting data is now as easy as ABC
            </span>
          </>
        }
        // text={`Collecting \n data is now as \n easy as ABC`}
        buttonText="Apply now"
        href={typeformUrl}
      />
    </Typograf>
  );
};

export default HowMakes;
